import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HomeRounded, BoltRounded } from '@mui/icons-material';
import { ROUTES } from '../../config/routes';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const NotFoundPage = () => {
  useDocumentTitle('404 — Not Found');
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <BoltRounded sx={{ color: 'primary.main', fontSize: 48, mb: 2 }} />
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '6rem', md: '9rem' },
            fontWeight: 900,
            color: 'primary.main',
            lineHeight: 1,
            mb: 1,
          }}
        >
          404
        </Typography>
        <Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>
          Page not found
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 5 }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<HomeRounded />}
          onClick={() => navigate(ROUTES.HOME)}
          sx={{ px: 4 }}
        >
          Back to Home
        </Button>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
